export const fieldList = [
  {
    label: '询价单编号',
    type: 'input',
    value: 'enquiryNo',
  },
  {
    label: '询价单名称',
    type: 'input',
    value: 'enquiryName',
  },
  {
    label: '询价发起人',
    type: 'input',
    value: 'createMemberName',
  },
  {
    label: '询价单状态',
    type: 'select',
    value: 'enquiryStatus',
    list: 'enquiryStatusList',
  },

  {
    label: '结算方式',
    type: 'select',
    value: 'isDoC',
    list: 'isDoCList',
  },
  {
    label: '配送方式',
    type: 'select',
    value: 'shipmentType',
    list: 'shipmentTypeList',
  },
  {
    label: '运费',
    type: 'select',
    value: 'includeFreight',
    list: 'includeFreightList',
  },
  {
    label: '询价来源',
    type: 'select',
    value: 'createSource',
    list: 'createSourceOptions',
  },
  {
    label: '报价开始时间',
    type: 'date',
    value: 'releaseTime',
    dateType: 'datetimerange',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    defaultTime: ['00:00:00', '23:59:59'],
  },
  {
    label: '报价截止时间',
    type: 'date',
    value: 'time',
    defaultTime: ['00:00:00', '23:59:59'],
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    dateType: 'daterange',
  },
  {
    label: '询价发布时间',
    type: 'date',
    value: 'createTime',
    dateType: 'datetimerange',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    defaultTime: ['00:00:00', '23:59:59'],
  },
];

export const listTypeInfo = {
  // 询价状态
  enquiryStatusList: [
    { name: '全部', id: null },
    { name: '草稿', id: 0 },
    { name: '待平台审核', id: 1 },
    { name: '待报价', id: 2 },
    { name: '询价完成', id: 5 },
    { name: '生成订单', id: 7 },
    { name: '询价作废', id: 8 },
    { name: '审核拒绝', id: 9 },
    { name: '询价过期', id: 10 },
    { name: '待审批', id: 11 },
    { name: '选商定价待审批', id: 12 },
    { name: '审批拒绝', id: 13 },
    /* { name: '中选通知待确认', id: 14 }, */
  ],
  // 结算方式
  isDoCList: [
    { name: '全部', id: null },
    { name: '款到发货', id: 0 },
    { name: '货到付款', id: 1 },
  ],
  // 配送方式
  shipmentTypeList: [
    { name: '全部', id: null },
    { name: '卖家自行配送', id: 1 },
    { name: '第三方物流', id: 3 },
  ],
  includeFreightList: [
    { name: '全部', id: null },
    { name: '包含在商品中', id: 0 },
    { name: '单独明细提报', id: 1 },
  ],
  createSourceOptions: [
    { name: '全部', id: null },
    { name: '平台询价', id: 0 },
    { name: '石化询价', id: 1 },
  ],
};

export const tableLabel = [
  {
    label: '询价单号',
    param: 'enquiryNo',
    align: 'center',
    minWidth: 160,
  },
  {
    label: '询价单名称',
    param: 'enquiryName',
    align: 'center',
    minWidth: 260,
  },
  {
    label: '询价单状态',
    param: 'enquiryStatus',
    align: 'center',
    slot: 'enquiryStatus',
    minWidth: 140,
  },
  {
    label: '供应商报价',
    param: 'quotationCount',
    align: 'center',
    slot: 'quotationCount',
    minWidth: 140,
  },
  {
    label: '延期次数',
    param: 'delaysCount',
    align: 'center',
    minWidth: 100,
  },
  {
    label: '报价开始时间',
    param: 'releaseTime',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '报价截止时间',
    param: 'quotationDeadline',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '询价发布时间',
    param: 'createTime',
    align: 'center',
    minWidth: 180,
  },

  {
    label: '运费',
    slot: 'includeFreight',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '结算方式',
    slot: 'isDoC',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '配送方式',
    slot: 'shipmentType',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '询价来源',
    align: 'center',
    slot: 'createSource',
    minWidth: 140,
  },
  {
    label: '联系人',
    param: 'realName',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '联系方式',
    param: 'mobile',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '邮箱',
    param: 'email',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '收货地址',
    param: 'address',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '询价发起人',
    param: 'createMemberName',
    align: 'center',
    minWidth: 180,
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    slot: 'handle',
    width: 220,
  },
];

// seeDetails.vue
export const negotiationRemark = {
  data() {
    return {
      purchaseTableData: [],
      purchaseTableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'center',
          width: '220px',
        },
        {
          label: '品牌',
          param: 'brandName',
          align: 'center',
          width: '120px',
        },
        {
          label: '规格型号',
          param: 'specifications',
          align: 'center',
          width: '120px',
        },
        {
          label: '商品描述',
          param: 'productDescription',
          align: 'center',
          width: '220px',
        },
        {
          label: '需求数量',
          param: 'requiredQuantity',
          align: 'center',
          width: '220px',
        },
        {
          label: '计量单位',
          param: 'unitName',
          align: 'center',
          width: '220px',
        },
        {
          label: '报价单价（含税）',
          align: 'center',
          width: '220px',
          slot: 'price',
        },
        {
          label: '税率（%）',
          param: 'taxRate',
          align: 'center',
          width: '220px',
        },
        {
          label: '小计',
          align: 'center',
          width: '120px',
          slot: 'totalPrice',
          fixed: 'right',
        },
      ],
    };
  },
  computed: {
    totalPrice() {
      const result = this.purchaseTableData.reduce((total, item) => {
        return total + item.price * item.requiredQuantity;
      }, 0);
      return result.toFixed(2);
    },
  },

  methods: {
    cacu(row) {
      row.totalPrice = (row.price * row.requiredQuantity).toFixed(2);
      return row.totalPrice;
    },
  },
};
